import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
} from "react";

export type PressedStationIdContextType = {
  pressedStationId: string | null;
  setPressedStationId: Dispatch<SetStateAction<string | null>> | null;
};

export const PressedStationIdContext =
  createContext<PressedStationIdContextType>({
    pressedStationId: null,
    setPressedStationId: null,
  });

export const PressedStationIdProvider: React.FC<
  React.PropsWithChildren<NonNullable<unknown>>
> = ({ children }) => {
  const [pressedStationId, setPressedStationId] = useState<string | null>(null);

  return (
    <PressedStationIdContext.Provider
      value={{ pressedStationId, setPressedStationId }}
    >
      {children}
    </PressedStationIdContext.Provider>
  );
};

export default PressedStationIdProvider;
